import React from 'react'
import { graphql } from 'gatsby'
import { Background, Container, Section } from '../../components/page'
//import { Image } from '../../components/image'
import {
  Swiper,
  SwiperSlide,
  Navigation,
  Pagination,
  SwiperProps,
  Next,
  Prev,
  Dots,
} from '../../components/slider'

import * as styles from './testimonials.module.scss'

export type TestimonialsProps = Queries.TestimonialsFragment

const swiperProps: SwiperProps = {
  modules: [Navigation, Pagination],
  slidesPerView: 1,
  spaceBetween: 0,
}

export const Testimonials = ({ items }: TestimonialsProps) => {
  return (
    <Section className={styles.section}>
      <Container className={styles.container}>
        <div className={styles.wrapper}>
          <Swiper
            {...swiperProps}
            className={styles.slider}
            navigation={{
              prevEl: `.${styles.prev}`,
              nextEl: `.${styles.next}`,
            }}
            pagination={{
              el: `.${styles.pagination}`,
              clickable: true,
            }}
          >
            {items?.map((item) => (
              <SwiperSlide key={item?.id} className={styles.slide}>
                <div className={styles.item}>
                  {/*
                  <div className={styles.image}>
                    <Image
                      image={item?.image}
                      alt={item?.image?.title!}
                      loading="lazy"
                    />
                  </div>
                  */}
                  <p className={styles.text}>{item?.text?.text}</p>
                  <h4 className={styles.name}>{item?.name}</h4>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <Prev className={styles.prev} aria-label="Previous button" />
          <Next className={styles.next} aria-label="Previous button" />
          <Dots className={styles.pagination} />
        </div>
      </Container>
      <Background variant="testimonials" />
    </Section>
  )
}

export const TestimonialsFragments = graphql`
  fragment TestimonialImage on ContentfulAsset {
    __typename
    id
    title
    gatsbyImageData(width: 70, height: 70)
  }
  fragment Testimonial on ContentfulTestimonial {
    __typename
    id
    name
    text {
      text
    }
    image {
      ...TestimonialImage
    }
  }
  fragment Testimonials on ContentfulTestimonials {
    __typename
    id
    title
    items {
      ...Testimonial
    }
  }
`
